import { createAction, props } from '@ngrx/store';
import { IDeleteBenchmarkGlobalRequest } from '../models/benckmark.model';

export const loadDeleteBenchmarkGlobals = createAction(
  '[DeleteBenchmarkGlobal] Load DeleteBenchmarkGlobals',
  props<{ request: IDeleteBenchmarkGlobalRequest }>()
);

export const loadDeleteBenchmarkGlobalsSuccess = createAction(
  '[DeleteBenchmarkGlobal] Load DeleteBenchmarkGlobals Success',
  props<{ response: string }>()
);

export const loadDeleteBenchmarkGlobalsFailure = createAction(
  '[DeleteBenchmarkGlobal] Load DeleteBenchmarkGlobals Failure',
  props<{ error: Error | any }>()
);
